/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the Workspace HTTP resource (factory product). */
export class WorkspaceResource {
}

function transformRequest(data: any): any {
  const transformed = _.cloneDeep(data);
  if (_.has(transformed, 'data') && !_.isString(transformed.data)) {
    transformed.data = JSON.stringify(transformed.data);
  }
  return transformed;
}

function transformResponse(data: any): any {
  if (_.isString(_.get(data, 'data'))) {
    try {
      data.data = JSON.parse(data.data);
    } catch (_err) {
      // The API also permits plain strings.
    }
  }
  return data;
}

export function createWorkspaceResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  return createAdnHttpResource(
    createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler),
    'workspaces',
    () => localUserProfile,
    undefined,
    undefined,
    {transformRequest, transformResponse}
  );
}

export const workspaceResourceProvider = {
  provide: WorkspaceResource,
  useFactory: createWorkspaceResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

